import axios from 'axios'

export default {
  state: {
    serverTime: null,
  },
  getters: {
    ServerTime: (s) => s.serverTime,
  },
  mutations: {
    updateServerTime(state, time) {
      state.serverTime = time
    },
  },
  actions: {
    fetchServerTime(ctx) {
      return axios({
        method: 'GET',
        url: 'api/auth/server-time/',
      })
        .then((response) => {
          const time = response.data
          ctx.commit('updateServerTime', time)
          return true
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
